export default __webpack_public_path__ + "static/media/banking_limit_monitoring_icon.8e39341d.svg";